// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  homologationBannerEnabled: true,
  API: 'https://dev.shineraydobrasil.com.br/api/',
  API_PROTHEUS: 'https://dev.shineraydobrasil.com.br:8095/rest/', 
  versao: '2.0.31',

  getnetLoaderUrl: 'https://checkout-homologacao.getnet.com.br/loader.js',
  getnetSellerid: 'ec6899b0-e6b8-4921-b822-faac35df0ff0'
};

/*
 * For easier debugging in development mode, you can import the following file\
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
